
import styles from './Activity.module.scss';
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import common from '../../../common';
import { useLocation, useNavigate } from 'react-router-dom';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function Activity() {


    const { pToast, useAlert, useModal, useConfirm, useLoading } = common();
    const { pAlert, AlertComponent } = useAlert();
    const { pModal, ModalComponent} = useModal();
    const { pConfirm, ConfirmComponent} = useConfirm();
    const { pLoadingOn, pLoadingOff, LoadingComponent } = useLoading();
    const [data, setData] = useState({});


    

    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const pageid = queryParams.get('pageid');

    const [activeTab, setActiveTab] = useState(1);
    useEffect(() => {
        if (pageid) {
            setActiveTab(Number(pageid));
        }
    }, [pageid]);

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        navigate(`?pageid=${tabIndex}`);
    };


    return (
        <>
            <div className="components_wrap">
                <span className='components_wrap_title'>주요 활동</span>

                <div className={styles.tab_box}>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 1 ? styles.active : ''}`}
                        onClick={() => handleTabClick(1)}
                    >
                        사회공헌활동
                    </button>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 2 ? styles.active : ''}`}
                        onClick={() => handleTabClick(2)}
                    >
                        학술교류활동
                    </button>
                    <button
                        className={`${styles.tab_btn} ${activeTab === 3 ? styles.active : ''}`}
                        onClick={() => handleTabClick(3)}
                    >
                        회원교류활동
                    </button>
                </div>

                {activeTab === 1 && ( 
                    <>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>주니어 공학기술교실</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_1_1.jpg" alt="activity_1_1" />
                                </div>
                                <div className={styles.activity_cont}>
                                    주니어 공학기술교실은 초등학생들에게 과학과 공학에 대한 흥미를 높이고, 과학적 · 공학적 소양을 키울 수 있는 경험을 제공하기 위해 2004년부터 시작된 프로그램입니다. 또한, YEHS 회원들이 차세대 공학 리더로서 사회에 공헌할 수 있는 리더십을 함양하는 계기를 마련하고자 합니다. 이 프로그램은 과학 및 공학적 경험에서 소외된 초등학교와 지역 아동센터를 직접 방문하여, 학생들이 공학 키트를 제작하고 체험하는 활동으로 진행됩니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>고교방문 전공설명회</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_1_2.jpg" alt="activity_1_2" />
                                </div>
                                <div className={styles.activity_cont}>
                                    전공설명회는 다양한 공학 전공자들로 구성된 YEHS 회원들이 고등학생들에게 자신의 학과와 진로를 소개하는 행사입니다. 이 행사는 각 전공에 대한 구체적이고 유익한 정보를 제공함으로써, 학생들이 전공에 대한 명확한 이해를 바탕으로 진학 목표를 설정할 수 있도록 돕는 데 목적이 있습니다. 연사 발표 후에는 Q&A 시간을 통해 학생들이 전공, 대학 생활, 입시 등에 관해 자유롭게 질문하며, 궁금증을 해소하고 공학을 포함한 다양한 학과에 대한 관심을 키울 수 있는 기회를 제공합니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>슬기로운 공대생활</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_1_3.jpg" alt="activity_1_3" />
                                </div>
                                <div className={styles.activity_cont}>
                                    슬기로운 공대생활은 YEHS 회원들이 공학 계열 전공에 관심 있는 학생들을 대상으로 진행하는 인터뷰 형식의 행사입니다. 더 많은 대상에게 공학의 정보를 전달하기 위해 기획되었으며, 단순히 전공 소개에 그치지 않고 현직 종사자들의 경험담도 함께 들을 수 있는 기회를 제공합니다. 이를 통해 각 전공에서 배우는 내용, 실제 학습 과정, 그리고 진로를 준비하기 위해 필요한 역량에 대해 깊이 있는 정보를 제공하며, 학생들이 보다 구체적으로 미래를 설계할 수 있도록 돕습니다
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {activeTab === 2 && ( 
                    <>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>정기세미나</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_1.jpg" alt="activity_2_1" />
                                </div>
                                <div className={styles.activity_cont}>
                                    정기세미나는 YEHS 회원들을 연사로 섭외하여 공학 기반의 전공 지식을 교류하는 활동입니다.  산업계 또는 학계에서 활동중이신 2명의 연사 분들이 특정한 주제에 대해 각각 발표를 진행하고, 회원들과 함께 질의응답 시간을 가집니다. 공학에 관련된 최신 트렌드와 기술부터 현 사회의 이슈, 전공 지식 및 연구 등을 주제로 하며 YEHS 회원들의 공학적 안목을 넓히고 역량을 증진시키고자 하는 취지의 행사입니다. 
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>차세대 테크 리더십포럼</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_2.jpg" alt="activity_2_2" />
                                </div>
                                <div className={styles.activity_cont}>
                                    학계와 산업계의 전문가이신 연사님들의 강연을 통해 현재 산업과 기술의 동향, 미래 기술의 방향성 등 다양한 인사이트를 얻을 수 있는 행사입니다. 특히 QnA & Polling 시스템을 통해 효과적인 소통과 수준 높은 질의응답이 가능합니다. 본 포럼은 공학에 관심 있는 누구나 참여 가능한 포럼으로, YEHS 회원들 뿐만 아니라 많은 사람들과 함께 기술과 세상에 관하여 생각해볼 수 있는 행사입니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>진로가이드세미나</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_3.jpg" alt="activity_2_3" />
                                </div>
                                <div className={styles.activity_cont}>
                                    다양한 분야에 종사 중이신 YEHS 시니어 회원들이 YEHS 주니어 회원들에게 학업 및 진로와 관련하여 정보와 조언을 제공하는 세미나입니다. 전국 최고의 공대생 네트워크인 YEHS의 인프라를 이용하여, 취업/진학/창업 등 다양한 분야로 진출한 YEHS 시니어 회원들의 실질적인 조언을 통해 회원들의 진로 설정 및 고민 해소에 도움을 줍니다. 그룹별로 연사님의 강연을 듣고 자유롭게 질의응답을 할 수 있어 효과적인 소통과 정보 공유가 가능합니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>진로가이드세미나 유학편</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_4.png" alt="activity_2_4" />
                                </div>
                                <div className={styles.activity_cont}>
                                    해외 유학과 관련된 진로 정보 제공을 목적으로 하는 행사입니다. 해외 대학의 석사/박사과정 혹은 교수직에 있거나 유학 후 국내외에서 활동하고 계신 YEHS 시니어 연사 분들의 상세한 유학 준비 과정 및 수기를 소개하며, 글로벌 커리어를 갖추기 위한 특별 노하우를 공유합니다. 온라인으로 진행하는 행사로, 국내에 거주하는 회원들이 시공간 제약에 구애받지 않고 다른 국가에 있는 YEHS 회원들과 활발히 교류할 수 있습니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>YEHS 아이디어톤</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_5.jpg" alt="activity_2_5" />
                                </div>
                                <div className={styles.activity_cont}>
                                    아이디어톤은 다양한 관심 분야와 능력을 지닌 YEHS 회원들이 한 팀을 이루어 기술과 지식을 공학적 아이디어와 융합해 3주간 문제를 해결하는 솔루션을 도출해내는 대회입니다. 아이디어톤을 통해 YEHS 회원들의 잠재력과 능력을 발휘하고 교류하여 함께 성장할 수 있습니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>산업체방문</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_6.jpeg" alt="activity_2_6" />
                                </div>
                                <div className={styles.activity_cont}>
                                    산업체, 연구소 방문은 국내 유수 기업이나 연구소를 방문하는 행사입니다. 학교에서 배운 공학 지식이 실제로 적용되는 현장을 참관함으로써 공학에 대한 현장감을 기를 수 있고, 자신의 미래 직업에 대해서도 생각해 볼 수 있습니다. 도전적이고 열정적인 대학생의 시선으로 우리나라 기업과 연구소를 직접 체험하는 생동감 넘치는 행사입니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>특별세미나</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_2_7.jpg" alt="activity_2_7" />
                                </div>
                                <div className={styles.activity_cont}>
                                    공학적 주제에서 벗어나 인문학, 경제학 등 회원들이 차세대 리더로서 성장하는 데 필요한 폭넓은 인사이트 제공을 목적으로 합니다. 특별세미나를 통해 공학 이외의 다양한 분야에 대한 지식과 견문의 확대를 도모할 수 있습니다.
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {activeTab === 3 && ( 
                    <>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>YEHS 홈커밍데이</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_3_1.jpeg" alt="activity_3_1" />
                                </div>
                                <div className={styles.activity_cont}>
                                    YEHS의 홈커밍데이인 YEHSociety는 주니어와 시니어 회원들이 한자리에 모여 교류하며, YEHS의 성과를 함께 되돌아보는 특별한 시간입니다. 이 행사는 회원들에게 소속감과 자긍심을 고취하고, YEHS가 최고의 공학도 네트워크로서 앞으로도 지속적으로 성장할 것을 다짐하는 의미 있는 자리입니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>YEHS 워크샵</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_3_2.jpg" alt="activity_3_2" />
                                </div>
                                <div className={styles.activity_cont}>
                                    YEHS 워크샵은 YEHS 주니어와 시니어 회원의 네트워크 활성화에 초점을 맞춘 회원 교류 행사입니다. 전 회원을 대상으로 하는 대규모 행사로, 새로운 네트워크를 구축하고 기존 네트워크를 강화하는 화합의 장으로서 YEHS 회원 간 소통과 협력을 증진하고 내부 결속을 다지는 다양한 프로그램을 진행합니다.
                                </div>
                            </div>
                        </div>
                        <div className={styles.activity_box}>
                            <div className={styles.activity_title}>YEHS 정기총회</div>
                            <div className={styles.activity_cont_box}>
                                <div className={styles.activity_img}>
                                    <img src="/img/activity_3_3.jpg" alt="activity_3_3" />
                                </div>
                                <div className={styles.activity_cont}>
                                    YEHS의 제반 활동과 전반적인 운영에 대한 사안을 토의 및 결정하고 내년도 YEHS의 개선점과 방향성에 대해 논의하는 행사입니다. 더불어 한 해를 마무리하는 송년회를 통해 YEHS 회원 사이 교류의 장을 마련하여 공학도 네트워크를 활성화합니다.
                                </div>
                            </div>
                        </div>
                    </>
                )}
                
            </div>
        </>
    );
}

export default Activity;